// sticky-atc.js - Fixed Currency Version
class ShopifyStickyAtcBar {
  constructor() {
    this.stickyBar = document.getElementById('stickyAtcBar');
    
    // Load product data including currency info
    this.loadProductData();
    
    // Find the main product form and its ProductForm instance
    this.mainForm = this.findMainProductForm();
    this.productFormInstance = this.findProductFormInstance();
    
    this.variantSelect = document.getElementById('stickyVariant');
    this.priceElement = document.getElementById('stickyPrice');
    this.quantityInput = document.getElementById('stickyQuantity');
    this.atcButton = document.getElementById('stickyAtcBtn');
    
    if (!this.stickyBar) {
      console.error('Sticky bar element not found!');
      return;
    }
    
    this.init();
  }
  
  // NEW: Load product data including currency information
  loadProductData() {
    const productDataScript = document.getElementById('sticky-product-data');
    if (productDataScript) {
      try {
        this.productData = JSON.parse(productDataScript.textContent);
        this.currency = this.productData.currency || 'USD';
        this.moneyFormat = this.productData.money_format || '${{amount}}';
      } catch (error) {
        console.error('Error parsing product data:', error);
        this.currency = 'USD';
        this.moneyFormat = '${{amount}}';
      }
    } else {
      console.warn('Product data script not found, using defaults');
      this.currency = 'USD';
      this.moneyFormat = '${{amount}}';
    }
  }
  
  findMainProductForm() {
    const selectors = [
      'product-form',
      '.product-form',
      'form[action*="/cart/add"]',
      '.product__form',
      '.product-single__form',
      '.shopify-product-form',
      '.product-form-container',
      '.main-product-form',
      '.f-main-product-form',
      '#product-form',
      '[data-product-form]'
    ];
    
    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        return element;
      }
    }
    
    return null;
  }
  
  findProductFormInstance() {
    const productFormElement = document.querySelector('product-form');
    if (productFormElement) {
      return productFormElement;
    }
    
    return null;
  }
  
  init() {
    this.setupIntersectionObserver();
    this.setupEventListeners();
    this.updateStickyBarHeight();
    this.updateVariant();
    this.syncWithMainForm();
  }
  
  setupIntersectionObserver() {
    if (!this.mainForm) {
      this.showStickyBar();
      return;
    }
    
    const options = {
      threshold: 0.1,
      rootMargin: '-80px 0px 0px 0px'
    };
    
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.hideStickyBar();
        } else {
          this.showStickyBar();
        }
      });
    }, options);
    
    this.observer.observe(this.mainForm);
  }
  
  setupEventListeners() {
    if (this.variantSelect) {
      this.variantSelect.addEventListener('change', () => {
        this.updateVariant();
        this.syncVariantWithMainForm();
      });
    }
    
    this.setupMainFormSync();
    
    window.addEventListener('resize', () => {
      this.updateStickyBarHeight();
    });
  }
  
  setupMainFormSync() {
    const mainVariantSelects = document.querySelectorAll('input[name="id"], select[name="id"], .product-form__input input[type="radio"]');
    
    mainVariantSelects.forEach(input => {
      input.addEventListener('change', () => {
        this.syncFromMainForm();
      });
    });
    
    const variantOptions = document.querySelectorAll('.product-form__input input[type="radio"], .product-form__input select');
    variantOptions.forEach(option => {
      option.addEventListener('change', () => {
        setTimeout(() => {
          this.syncFromMainForm();
        }, 100);
      });
    });
  }
  
  syncFromMainForm() {
    const mainVariantInput = document.querySelector('input[name="id"]');
    if (mainVariantInput && this.variantSelect) {
      const variantId = mainVariantInput.value;
      
      if (this.variantSelect.tagName === 'SELECT') {
        this.variantSelect.value = variantId;
      } else {
        this.variantSelect.value = variantId;
      }
      
      this.updateVariant();
    }
  }
  
  syncVariantWithMainForm() {
    const mainVariantInput = document.querySelector('input[name="id"]');
    if (mainVariantInput && this.variantSelect) {
      const variantId = this.variantSelect.value;
      
      mainVariantInput.value = variantId;
      
      const changeEvent = new Event('change', { bubbles: true });
      mainVariantInput.dispatchEvent(changeEvent);
    }
  }
  
  syncWithMainForm() {
    this.syncFromMainForm();
  }
  
  updateStickyBarHeight() {
    const height = this.stickyBar.offsetHeight;
    document.documentElement.style.setProperty('--sticky-atc-height', `${height}px`);
  }
  
  showStickyBar() {
    this.stickyBar.classList.add('show');
    document.body.classList.add('has-sticky-atc');
  }
  
  hideStickyBar() {
    this.stickyBar.classList.remove('show');
    document.body.classList.remove('has-sticky-atc');
  }
  
  updateVariant() {
    if (!this.variantSelect) {
      return;
    }
    
    let selectedOption, price, comparePrice, available;
    
    if (this.variantSelect.tagName === 'SELECT') {
      selectedOption = this.variantSelect.selectedOptions[0];
      price = selectedOption.dataset.price;
      comparePrice = selectedOption.dataset.comparePrice;
      available = selectedOption.dataset.available === 'true';
    } else {
      price = this.variantSelect.dataset.price;
      comparePrice = this.variantSelect.dataset.comparePrice;
      available = this.variantSelect.dataset.available === 'true';
    }
    
    // Update price display
    let priceHtml = '';
    if (comparePrice && comparePrice > price) {
      priceHtml = `<span class="compare-price">${this.formatMoney(comparePrice)}</span>`;
      this.priceElement.classList.add('on-sale');
    } else {
      this.priceElement.classList.remove('on-sale');
    }
    priceHtml += this.formatMoney(price);
    this.priceElement.innerHTML = priceHtml;
    
    // Update button state
    if (available) {
      this.atcButton.disabled = false;
      this.atcButton.textContent = 'Add to Cart';
      this.atcButton.classList.remove('sold-out');
    } else {
      this.atcButton.disabled = true;
      this.atcButton.textContent = 'Sold Out';
      this.atcButton.classList.add('sold-out');
    }
  }
  
  // FIXED: Use proper currency formatting like in price.liquid
  formatMoney(cents) {
    if (!cents || cents === '0') {
      return this.moneyFormat.replace('{{amount}}', '0.00');
    }
    
    // Convert cents to dollars
    const amount = (parseInt(cents) / 100).toFixed(2);
    
    // Use the shop's money format
    return this.moneyFormat.replace('{{amount}}', amount);
  }
  
  addToCart() {
    if (!this.productFormInstance) {
      this.fallbackAddToCart();
      return;
    }
    
    this.syncQuantityToMainForm();
    this.syncVariantWithMainForm();
    
    try {
      const form = this.productFormInstance.querySelector('form');
      if (form) {
        const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
        form.dispatchEvent(submitEvent);
        
        this.showLoadingState();
      } else {
        this.fallbackAddToCart();
      }
    } catch (error) {
      this.fallbackAddToCart();
    }
  }
  
  syncQuantityToMainForm() {
    const mainQuantityInput = document.querySelector('input[name="quantity"]');
    if (mainQuantityInput && this.quantityInput) {
      mainQuantityInput.value = this.quantityInput.value;
    }
  }
  
  showLoadingState() {
    if (this.atcButton) {
      this.atcButton.classList.add('loading');
      this.atcButton.disabled = true;
      const originalText = this.atcButton.textContent;
      this.atcButton.textContent = 'Adding...';
      
      setTimeout(() => {
        this.atcButton.classList.remove('loading');
        this.atcButton.disabled = false;
        this.atcButton.textContent = originalText;
      }, 3000);
    }
  }
  
  fallbackAddToCart() {
    const variantId = this.variantSelect ? this.variantSelect.value : null;
    const quantity = this.quantityInput ? parseInt(this.quantityInput.value) : 1;
    
    if (!variantId) {
      return;
    }
    
    this.showLoadingState();
    
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.status) {
        this.showNotification(data.description || 'Error adding to cart', 'error');
      } else {
        this.showNotification('Added to cart!');
        
        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else if (cartNotification && typeof cartNotification.renderContents === 'function') {
          cartNotification.renderContents(data);
        }
      }
    })
    .catch(error => {
      this.showNotification('Error adding to cart', 'error');
    })
    .finally(() => {
      this.atcButton.classList.remove('loading');
      this.atcButton.disabled = false;
      this.atcButton.textContent = 'Add to Cart';
    });
  }
  
  showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#10b981' : '#ef4444'};
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      z-index: 10000;
      font-size: 14px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      transition: all 0.3s ease;
    `;
    notification.textContent = message;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transform = 'translateY(-20px)';
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }
}

// Utility functions
function changeStickyQuantity(change) {
  const quantityInput = document.getElementById('stickyQuantity');
  if (quantityInput) {
    const currentValue = parseInt(quantityInput.value);
    const newValue = Math.max(1, currentValue + change);
    quantityInput.value = newValue;
  }
}

function addToCartSticky() {
  if (window.shopifyStickyAtcBar) {
    window.shopifyStickyAtcBar.addToCart();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const stickyBarElement = document.getElementById('stickyAtcBar');
  if (stickyBarElement) {
    window.shopifyStickyAtcBar = new ShopifyStickyAtcBar();
  }
});

// Also try initializing after a delay in case of timing issues
setTimeout(() => {
  if (!window.shopifyStickyAtcBar) {
    const stickyBarElement = document.getElementById('stickyAtcBar');
    if (stickyBarElement) {
      window.shopifyStickyAtcBar = new ShopifyStickyAtcBar();
    }
  }
}, 1000);